document.addEventListener('DOMContentLoaded', function() {
    const accordionBlocks = document.querySelectorAll('.wp-block-pulp-accordion');
    
    accordionBlocks.forEach(function(accordionBlock) {
        const accordionItems = accordionBlock.querySelectorAll('.accordion__item');
        const imageWrappers = accordionBlock.querySelectorAll('.accordion__image-wrapper');
        
        accordionItems.forEach(function(item) {
            const trigger = item.querySelector('.accordion__trigger');
            const content = item.querySelector('.accordion__content-inner');
            const index = item.getAttribute('data-index');
            
            trigger.addEventListener('click', function(e) {
                e.preventDefault();
                
                const isActive = item.classList.contains('is-active');
                
                if (isActive) {
                    item.classList.remove('is-active');
                    trigger.setAttribute('aria-expanded', 'false');
                    content.setAttribute('aria-hidden', 'true');
                    return;
                } 

                
                // Close all other accordion items
                accordionItems.forEach(function(otherItem) {
                    if (otherItem !== item) {
                        const otherTrigger = otherItem.querySelector('.accordion__trigger');
                        const otherContent = otherItem.querySelector('.accordion__content-inner');
                        
                        otherItem.classList.remove('is-active');
                        otherTrigger.setAttribute('aria-expanded', 'false');
                        otherContent.setAttribute('aria-hidden', 'true');
                    }
                });
                
                item.classList.add('is-active');
                trigger.setAttribute('aria-expanded', 'true');
                content.setAttribute('aria-hidden', 'false');
                
                // Update image
                updateImage(index, imageWrappers);
            });
        });
        
        function updateImage(activeIndex, wrappers) {
            wrappers.forEach(function(wrapper) {
                const wrapperIndex = wrapper.getAttribute('data-index');
                
                if (wrapperIndex === activeIndex) {
                    wrapper.classList.add('is-active');
                } else {
                    wrapper.classList.remove('is-active');
                }
            });
        }
    });
}); 